import React from 'react'
import { UserManager } from 'oidc-client'
import { resolve } from '../dependencies'

export default class LoginCallback extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      brukernavn: '',
      passord: '',
      feilmelding: '',
      laster: false
    }
    this.onSigninComplete = this.onSigninComplete.bind(this)
  }

  onSigninComplete(user) {       
    window.sessionStorage.setItem('bruker', user)
    this.props.history.push('/forside') 
  }


  componentDidMount() { 
    resolve(UserManager).signinRedirectCallback()
    .then(this.onSigninComplete)
      .catch(function (err) {
        console.log("feil i callback")
        console.log(err);
      });
  }

  render() {
    return null
  }
}


// WEBPACK FOOTER //
// ./src/felles/login-callback.jsx